import {TimeSelector} from './TimeSelector';
import {DropDownTimeSelector} from './DropDownTimeSelector';
import {MobileDropDownTimeSelector} from './MobileDropDownTimeSelector';

export const createTimeSelector = function createTimeSelector(times: number[], defaultTimeIndex: number,
    onSelect: (time: number) => void): TimeSelector {
    const isDesktop = document.body.classList.contains('desktop');

    if (isDesktop) {
        return new DropDownTimeSelector(times, defaultTimeIndex, onSelect);
    } else {
        return new MobileDropDownTimeSelector(times, defaultTimeIndex, onSelect);
    }
};
